import * as React from 'react';
import { FixMeLater } from '../../../utils';
import { Typography, TypographyBaseProps } from '../Typography';
import { TypographyHeadingSize, DEFAULT_HEADING_TAG_MAP, useComponentDefaultProps } from '../../../theming';

export interface HeadingProps extends TypographyBaseProps {
    size?: TypographyHeadingSize;
}

const defaultProps: Partial<HeadingProps> = {
    size: 'm',
    color: 'text.heading',
};

export const Heading: React.ForwardRefExoticComponent<HeadingProps & React.RefAttributes<HTMLElement>> =
    React.forwardRef(function Heading(props: HeadingProps, ref: React.ForwardedRef<FixMeLater>): React.JSX.Element {
        const {
            component: componentProp,
            size = 'm',
            ...other
        } = useComponentDefaultProps('Heading', defaultProps, props);

        return (
            <Typography
                ref={ref}
                family="heading"
                size={size}
                component={componentProp || DEFAULT_HEADING_TAG_MAP[typeof size === 'object' ? 'm' : size]}
                {...other}
            />
        );
    });
